import React, { useEffect, useRef, useState, useCallback } from 'react';
import { DECORACION } from '../../config/decoracion';
import { useNieve } from '../../context/NieveContext';
import './Nieve.css';

// Copos de nieve que caen sobre todo el sitio (decoración 'invierno').
// Modelo "spawn": mientras el mouse está sobre la animación del logo (activa)
// se van creando copos nuevos; cada copo cae UNA sola vez y se elimina al
// terminar. Al salir el mouse dejan de aparecer copos nuevos, pero los que ya
// están terminan de caer solos.
const CARACTERES = ['❄', '❅', '❆', '•', '•']; // ❄ ❅ ❆ • •

// Cada cuánto aparece un copo nuevo (ms). Con caídas de ~7-16s mantiene una
// densidad parecida a la anterior en pantalla.
const SPAWN_MS = 260;

const prefersReduced =
  typeof window !== 'undefined' &&
  window.matchMedia &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const crearCopo = (id) => ({
  id,
  left: Math.random() * 100, // % del ancho
  char: CARACTERES[Math.floor(Math.random() * CARACTERES.length)],
  size: 6 + Math.random() * 16, // 6px - 22px
  caida: 7 + Math.random() * 9, // 7s - 16s (los más chicos, más lentos)
  vaiven: 3 + Math.random() * 4, // 3s - 7s de balanceo lateral
  drift: 24 + Math.random() * 64, // px de vaivén horizontal
  opacity: 0.55 + Math.random() * 0.45,
});

const Nieve = () => {
  const { activa } = useNieve();
  const [copos, setCopos] = useState([]);
  const idRef = useRef(0);

  // Mientras está activa, genera copos nuevos. Al desactivarse se limpia el
  // intervalo (no aparecen más), pero los ya montados siguen cayendo.
  useEffect(() => {
    if (DECORACION !== 'invierno' || prefersReduced || !activa) return undefined;
    const intervalo = setInterval(() => {
      idRef.current += 1;
      setCopos((prev) => [...prev, crearCopo(idRef.current)]);
    }, SPAWN_MS);
    return () => clearInterval(intervalo);
  }, [activa]);

  const quitarCopo = useCallback((id) => {
    setCopos((prev) => prev.filter((c) => c.id !== id));
  }, []);

  if (DECORACION !== 'invierno' || prefersReduced || copos.length === 0) return null;

  return (
    <div className="nieve" aria-hidden="true">
      {copos.map((c) => (
        <span
          key={c.id}
          className="nieve__copo"
          style={{
            left: `${c.left}%`,
            fontSize: `${c.size}px`,
            opacity: c.opacity,
            animationDuration: `${c.caida}s`,
            '--drift': `${c.drift}px`,
          }}
          onAnimationEnd={(e) => {
            // Solo la caída del copo (no el vaivén interno) lo elimina.
            if (e.target === e.currentTarget) quitarCopo(c.id);
          }}
        >
          <span
            className="nieve__vaiven"
            style={{ animationDuration: `${c.vaiven}s` }}
          >
            {c.char}
          </span>
        </span>
      ))}
    </div>
  );
};

export default Nieve;
